import React from 'react';

import cn from 'classnames';
import type { LinkProps } from 'react-router-dom';
import { Link } from 'react-router-dom';
import './WhiteLabelBrand.sass';

type WhiteLabelBrandProps = Omit<LinkProps, 'to'>;

function WhiteLabelBrand({
  className = undefined,
  ...otherProps
}: WhiteLabelBrandProps): React.JSX.Element {
  return (
    <Link
      className={cn(className, 'WhiteLabelBrand')}
      to="/"
      {...otherProps}
    />
  );
}

WhiteLabelBrand.displayName = 'WhiteLabelBrand';

export { WhiteLabelBrand };
